{
	"languages": [
		{ "value": "en-US", "label": "English" },
		{ "value": "de-DE", "label": "Deutsch" },
		{ "value": "es-ES", "label": "Español" },
		{ "value": "fr-FR", "label": "Français" },
		{ "value": "it-IT", "label": "Italiano" },
		{ "value": "pl-PL", "label": "Polski" }
	],
	"brands": [
		{
			"name": "vw",
			"calcDomain": "VW.NEW",
			"markets": [
				{
					"name": "DEU",
					"ending": "de",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "£",
					"currency_previous": "£",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"
				}
			]
		},
		{
			"name": "audi",
			"calcDomain": "DID.AUDI.NEW.DE",
			"markets": [
				{
					"name": "DEU",
					"ending": "de",
					"currency": "€",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "GBP",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"}
			]
		},
		{
			"name": "bentley",
			"markets": [
				{
					"name": "DEU",
					"ending": "de",
					"currency": "EUR",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"
				},
				{
					"name": "GBR",
					"ending": "gb",
					"currency": "GBP",
					"nedc": true,
					"showMinimalEquipmentPopups": true,
					"qsUrl": "https://mpa.dev.did.b12-ssp.de",
					"prodUrl": "https://mpa.dev.did.b12-ssp.de"
				}
			]
		}
	]
}
